import LoadingSpinner from "app/components/LoadingSpinner/LoadingSpinner";
import { ResponsiveScreenSizes } from "app/utils/const";
import React, { lazy, Suspense } from "react";
import Media from "react-media";
import ReportTabs from "../ReportTabs/ReportTabs";
const FinanceSummary: React.LazyExoticComponent<any> = lazy(
  () => import("app/partials/FinanceSummary/FinanceSummary")
);

//
const ReportsScreenFinanceSummary = (
  props: Record<string, any>
): React.JSX.Element => {
  return (
    <div className="reports__finance-summary">
      <Media
        query={`(min-width: ${ResponsiveScreenSizes.desktop})`}
        render={() => <ReportTabs reportType={props.reportType} />}
      />
      <Suspense
        fallback={
          <div className="fallback">
            <LoadingSpinner />
          </div>
        }
      >
        <FinanceSummary />
      </Suspense>
    </div>
  );
};

export default ReportsScreenFinanceSummary;
